export const FIELD_WILDCARD = '*';
